import { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import API from "../axios";
import { useNavigate, useParams } from "react-router-dom";

const EditVehicleCMS = () => {
    const navigate = useNavigate();
    const { odooVehicleId } = useParams();

    const [hasData, setHasData] = useState(false);
    const [currentDataId, setCurrentDataId] = useState("");
    const [loading, setLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [error, setError] = useState(false);

    // Basic info
    const [active, setActive] = useState("false");
    const [queryString, setQueryString] = useState("");
    const [vehicleOdooId, setVehicleOdooId] = useState<number>(0);

    // Hero section
    const [coverImage, setCoverImage] = useState("");
    const [coverImageUploading, setCoverImageUploading] = useState(false);
    const [title, setTitle] = useState("");
    const [titleColor, setTitleColor] = useState("white");
    const [coverImageMobile, setCoverImageMobile] = useState("");
    const [coverImageMobileUploading, setCoverImageMobileUploading] =
        useState(false);

    // Spec grid
    const [subTitle1, setSubtitle1] = useState("");
    const [subTitle1Content, setSubTitle1Content] = useState("");
    const [subTitle2, setSubtitle2] = useState("");
    const [subTitle2Content, setSubTitle2Content] = useState("");
    const [subTitle3, setSubtitle3] = useState("");
    const [subTitle3Content, setSubTitle3Content] = useState("");

    // Section 1
    const [section1Image, setSection1Image] = useState("");
    const [section1ImageUploading, setSection1ImageUploading] = useState(false);
    const [section1Title, setSection1Title] = useState("");
    const [section1Content, setSection1Content] = useState("");

    // Slider 1
    const [sliders, setSliders] = useState<
        Array<{ image: string; title: string; content: string }>
    >([]);

    // Variant Slider
    const [variantSlider, setVariantSlider] = useState<
        Array<{ image: string; title: string; content: string }>
    >([]);

    const [currentVariantSliderImage, setCurrentVariantSliderImage] =
        useState("");
    const [currentVariantSliderTitle, setCurrentVariantSliderTitle] =
        useState("");
    const [currentVariantSliderContent, setCurrentVariantSliderContent] =
        useState("");
    const [variantSliderImageUploading, setVariantSliderImageUploading] =
        useState(false);
    const [variantSliderAddLoading, setVariantSliderAddLoading] =
        useState(false);
    const [variantSliderIndex, setVariantSliderIndex] = useState<number>(0);

    const [currentSliderImage, setCurrentSliderImage] = useState("");
    const [currentSliderTitle, setCurrentSliderTitle] = useState("");
    const [currentSliderContent, setCurrentSliderContent] = useState("");
    const [sliderImageUploading, setSliderImageUploading] = useState(false);
    const [sliderAddLoading, setSliderAddLoading] = useState(false);
    const [sliderIndex, setSliderIndex] = useState<number>(0);

    // Video 1
    const [video1, setVideo1] = useState("");

    // Section 2
    const [section2Title, setSection2Title] = useState("");
    const [section2Content, setSection2Content] = useState("");
    const [section2Grid1Icon, setSection2Grid1Icon] = useState("");
    const [section2Grid1IconUploading, setSection2Grid1IconUploading] =
        useState(false);
    const [section2Grid1Title, setSection2Grid1Title] = useState("");
    const [section2Grid1Content, setSection2Grid1Content] = useState("");
    const [section2Grid2Icon, setSection2Grid2Icon] = useState("");
    const [section2Grid2IconUploading, setSection2Grid2IconUploading] =
        useState(false);
    const [section2Grid2Title, setSection2Grid2Title] = useState("");
    const [section2Grid2Content, setSection2Grid2Content] = useState("");
    const [section2Grid3Icon, setSection2Grid3Icon] = useState("");
    const [section2Grid3IconUploading, setSection2Grid3IconUploading] =
        useState(false);
    const [section2Grid3Title, setSection2Grid3Title] = useState("");
    const [section2Grid3Content, setSection2Grid3Content] = useState("");

    // Section 3
    const [section3Title, setSection3Title] = useState("");
    const [section3Content, setSection3Content] = useState("");

    // Section 4
    const [section4Title, setSection4Title] = useState("");
    const [section4Content, setSection4Content] = useState("");

    // Slider 2
    const [slider2, setSlider2] = useState<
        Array<{ image: string; title: string; content: string }>
    >([]);
    const [currentSlider2Image, setCurrentSlider2Image] = useState("");
    const [currentSlider2Title, setCurrentSlider2Title] = useState("");
    const [currentSlider2Content, setCurrentSlider2Content] = useState("");
    const [slider2ImageUploading, setSlider2ImageUploading] = useState(false);
    const [slider2AddLoading, setSlider2AddLoading] = useState(false);
    const [slider2Index, setSlider2Index] = useState<number>(0);

    // Section 5
    const [section5Image, setSection5Image] = useState("");
    const [section5ImageUploading, setSection5ImageUploading] = useState(false);
    const [section5Title, setSection5Title] = useState("");
    const [section5Grid1Icon, setSection5Grid1Icon] = useState("");
    const [section5Grid1IconUploading, setSection5Grid1IconUploading] =
        useState(false);
    const [section5Grid1Title, setSection5Grid1Title] = useState("");
    const [section5Grid1Content, setSection5Grid1Content] = useState("");
    const [section5Grid2Icon, setSection5Grid2Icon] = useState("");
    const [section5Grid2IconUploading, setSection5Grid2IconUploading] =
        useState(false);
    const [section5Grid2Title, setSection5Grid2Title] = useState("");
    const [section5Grid2Content, setSection5Grid2Content] = useState("");
    const [section5Grid3Icon, setSection5Grid3Icon] = useState("");
    const [section5Grid3IconUploading, setSection5Grid3IconUploading] =
        useState(false);
    const [section5Grid3Title, setSection5Grid3Title] = useState("");
    const [section5Grid3Content, setSection5Grid3Content] = useState("");

    // Section 6
    const [section6Title, setSection6Title] = useState("");
    const [section6Content, setSection6Content] = useState("");
    const [section6Image, setSection6Image] = useState("");
    const [section6ImageUploading, setSection6ImageUploading] = useState(false);

    // Section 7
    const [section7Image, setSection7Image] = useState("");
    const [section7ImageUploading, setSection7ImageUploading] = useState(false);
    const [section7Title, setSection7Title] = useState("");
    const [section7Content, setSection7Content] = useState("");

    // Section 8
    const [section8Title, setSection8Title] = useState("");
    const [section8Content, setSection8Content] = useState("");

    // Section 9
    const [section9Image, setSection9Image] = useState("");
    const [section9ImageUploading, setSection9ImageUploading] = useState(false);
    const [section9Title, setSection9Title] = useState("");
    const [section9Content, setSection9Content] = useState("");

    // Spec photo
    const [specPhoto, setSpecPhoto] = useState("");
    const [specPhotoUploading, setSpecPhotoUploading] = useState(false);

    // Footer
    const [footerImage, setFooterImage] = useState("");
    const [footerImageUploading, setFooterImageUploading] = useState(false);
    const [footerImageMobile, setFooterImageMobile] = useState("");
    const [footerImageMobileUploading, setFooterImageMobileUploading] =
        useState(false);
    const [footerTitle, setFooterTitle] = useState("");
    const [footerTitleColor, setFooterTitleColor] = useState("black");
    const [footerSubtitle, setFooterSubtitle] = useState("");

    // Upload utilities
    const [isFileSizeLarge, setIsFileSizeLarge] = useState(false);
    const [selectedFileSize, setSelectedFileSize] = useState(0);
    const [currentUpload, setCurrentUpload] = useState("");

    const fileUploadRef = useRef<any>(null);

    const handleSave = async function () {
        setSaveLoading(true);

        if (!odooVehicleId) {
            console.log("Odoo vehicle id is required!");
            setSaveLoading(false);
            return false;
        }

        const data = {
            active: active == "true" || active,
            queryString,
            vehicleOdooId: parseInt(odooVehicleId),
            hero_image: coverImage,
            hero_image_mobile: coverImageMobile,
            hero_title: title,
            hero_title_color: titleColor,
            spec_grid1_title: subTitle1,
            spec_grid1_content: subTitle1Content,
            spec_grid2_title: subTitle2,
            spec_grid2_content: subTitle2Content,
            spec_grid3_title: subTitle3,
            spec_grid3_content: subTitle3Content,
            section1_image: section1Image,
            section1_title: section1Title,
            section1_content: section1Content,
            variantSlider,
            slider1: sliders,
            video1,
            section2_title: section2Title,
            section2_content: section2Content,
            section2_grid1_icon: section2Grid1Icon,
            section2_grid1_title: section2Grid1Title,
            section2_grid1_content: section2Grid1Content,
            section2_grid2_icon: section2Grid2Icon,
            section2_grid2_title: section2Grid2Title,
            section2_grid2_content: section2Grid2Content,
            section2_grid3_icon: section2Grid3Icon,
            section2_grid3_title: section2Grid3Title,
            section2_grid3_content: section2Grid3Content,
            section3_title: section3Title,
            section3_content: section3Content,
            section4_title: section4Title,
            section4_content: section4Content,
            slider2,
            section5_image: section5Image,
            section5_title: section5Title,
            section5_grid1_icon: section5Grid1Icon,
            section5_grid1_title: section5Grid1Title,
            section5_grid1_content: section5Grid1Content,
            section5_grid2_icon: section5Grid2Icon,
            section5_grid2_title: section5Grid2Title,
            section5_grid2_content: section5Grid2Content,
            section5_grid3_icon: section5Grid3Icon,
            section5_grid3_title: section5Grid3Title,
            section5_grid3_content: section5Grid3Content,
            section6_title: section6Title,
            section6_content: section6Content,
            section6_image: section6Image,
            section7_image: section7Image,
            section7_title: section7Title,
            section7_content: section7Content,
            section8_title: section8Title,
            section8_content: section8Content,
            section9_image: section9Image,
            section9_title: section9Title,
            section9_content: section9Content,
            spec_photo: specPhoto,
            footer_image: footerImage,
            footer_image_mobile: footerImageMobile,
            footer_title: footerTitle,
            footer_title_color: footerTitleColor,
            footer_subtitle: footerSubtitle,
        };

        try {
            if (hasData) {
                await API.updateVehicleCmsData(currentDataId, data);
            } else {
                await API.createVehicleCmsData(data);
                loadData();
            }
        } catch (error: any) {
            console.log(error);
            if (error.status == 400) {
                setError(true);
            }
        }

        setSaveLoading(false);
    };

    const toSlug = (s: string) => {
        return s
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, "") // remove punctuation except hyphen/space
            .replace(/\s+/g, "-") // spaces -> hyphens
            .replace(/-+/g, "-"); // collapse multiple hyphens
    };

    const loadData = async function () {
        setLoading(true);

        if (!odooVehicleId) {
            console.log("Odoo vehicle id is required!");
            setLoading(false);
            return false;
        }

        try {
            const vehicleResult: any = await API.getVehicleByOdooId(
                parseInt(odooVehicleId),
            );
            console.log(vehicleResult);
            const vehicleData = vehicleResult.data;

            setQueryString(toSlug(vehicleData.title));

            const result: any = await API.getVehicleCmsDataWithOdooId(
                parseInt(odooVehicleId),
            );
            const data = result.data;

            if (data) {
                setHasData(true);
                setCurrentDataId(data._id);

                setActive(data.active || false);
                setQueryString(data.queryString || "");
                setVehicleOdooId(data.vehicleOdooId || 0);
                setCoverImage(data.hero_image || "");
                setCoverImageMobile(data.hero_image_mobile || "");
                setTitle(data.hero_title || "");
                setTitleColor(data.hero_title_color || "black");
                setSubtitle1(data.spec_grid1_title || "");
                setSubTitle1Content(data.spec_grid1_content || "");
                setSubtitle2(data.spec_grid2_title || "");
                setSubTitle2Content(data.spec_grid2_content || "");
                setSubtitle3(data.spec_grid3_title || "");
                setSubTitle3Content(data.spec_grid3_content || "");
                setSection1Image(data.section1_image || "");
                setSection1Title(data.section1_title || "");
                setSection1Content(data.section1_content || "");
                setSliders(data.slider1 || []);
                setVariantSlider(data.variantSlider || []);
                setVideo1(data.video1 || "");
                setSection2Title(data.section2_title || "");
                setSection2Content(data.section2_content || "");
                setSection2Grid1Icon(data.section2_grid1_icon || "");
                setSection2Grid1Title(data.section2_grid1_title || "");
                setSection2Grid1Content(data.section2_grid1_content || "");
                setSection2Grid2Icon(data.section2_grid2_icon || "");
                setSection2Grid2Title(data.section2_grid2_title || "");
                setSection2Grid2Content(data.section2_grid2_content || "");
                setSection2Grid3Icon(data.section2_grid3_icon || "");
                setSection2Grid3Title(data.section2_grid3_title || "");
                setSection2Grid3Content(data.section2_grid3_content || "");
                setSection3Title(data.section3_title || "");
                setSection3Content(data.section3_content || "");
                setSection4Title(data.section4_title || "");
                setSection4Content(data.section4_content || "");
                setSlider2(data.slider2 || []);
                setSection5Image(data.section5_image || "");
                setSection5Title(data.section5_title || "");
                setSection5Grid1Icon(data.section5_grid1_icon || "");
                setSection5Grid1Title(data.section5_grid1_title || "");
                setSection5Grid1Content(data.section5_grid1_content || "");
                setSection5Grid2Icon(data.section5_grid2_icon || "");
                setSection5Grid2Title(data.section5_grid2_title || "");
                setSection5Grid2Content(data.section5_grid2_content || "");
                setSection5Grid3Icon(data.section5_grid3_icon || "");
                setSection5Grid3Title(data.section5_grid3_title || "");
                setSection5Grid3Content(data.section5_grid3_content || "");
                setSection6Title(data.section6_title || "");
                setSection6Content(data.section6_content || "");
                setSection6Image(data.section6_image || "");
                setSection7Image(data.section7_image || "");
                setSection7Title(data.section7_title || "");
                setSection7Content(data.section7_content || "");
                setSection8Title(data.section8_title || "");
                setSection8Content(data.section8_content || "");
                setSection9Image(data.section9_image || "");
                setSection9Title(data.section9_title || "");
                setSection9Content(data.section9_content || "");
                setSpecPhoto(data.spec_photo || "");
                setFooterImage(data.footer_image || "");
                setFooterImageMobile(data.footer_image_mobile || "");
                setFooterTitle(data.footer_title || "");
                setFooterTitleColor(data.footer_title_color || "black");
                setFooterSubtitle(data.footer_subtitle || "");
            }
        } catch (error) {
            console.log(error);
        }

        setLoading(false);
    };

    const handleFileChange = async function (e: any) {
        setIsFileSizeLarge(false);
        const file = e.target.files[0];

        console.log("file:", file);

        if (file) {
            if (currentUpload.trim().toLowerCase().includes("slider")) {
                // Check the file size
                let sizeInKb = file.size / 1024;
                if (sizeInKb > 500) {
                    setIsFileSizeLarge(true);
                    setSelectedFileSize(sizeInKb);

                    fileUploadRef.current.value = "";
                    return false;
                }
            }

            try {
                switch (currentUpload) {
                    case "main":
                        setCoverImageUploading(true);
                        const mainResult: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setCoverImage(mainResult.fileUrl);
                        setCoverImageUploading(false);
                        break;
                    case "main_mobile":
                        setCoverImageMobileUploading(true);
                        const mainMobileResult: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setCoverImageMobile(mainMobileResult.fileUrl);
                        setCoverImageMobileUploading(false);
                        break;
                    case "section1":
                        setSection1ImageUploading(true);
                        const section1Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection1Image(section1Result.fileUrl);
                        setSection1ImageUploading(false);
                        break;
                    case "variantSlider":
                        setVariantSliderImageUploading(true);
                        const sliderVariantResult: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setCurrentVariantSliderImage(
                            sliderVariantResult.fileUrl,
                        );
                        setVariantSliderImageUploading(false);
                        break;
                    case "slider":
                        setSliderImageUploading(true);
                        const sliderResult: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setCurrentSliderImage(sliderResult.fileUrl);
                        setSliderImageUploading(false);
                        break;
                    case "slider2":
                        setSlider2ImageUploading(true);
                        const slider2Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setCurrentSlider2Image(slider2Result.fileUrl);
                        setSlider2ImageUploading(false);
                        break;
                    case "section2Grid1Icon":
                        setSection2Grid1IconUploading(true);
                        const s2g1Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection2Grid1Icon(s2g1Result.fileUrl);
                        setSection2Grid1IconUploading(false);
                        break;
                    case "section2Grid2Icon":
                        setSection2Grid2IconUploading(true);
                        const s2g2Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection2Grid2Icon(s2g2Result.fileUrl);
                        setSection2Grid2IconUploading(false);
                        break;
                    case "section2Grid3Icon":
                        setSection2Grid3IconUploading(true);
                        const s2g3Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection2Grid3Icon(s2g3Result.fileUrl);
                        setSection2Grid3IconUploading(false);
                        break;
                    case "section5":
                        setSection5ImageUploading(true);
                        const section5Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection5Image(section5Result.fileUrl);
                        setSection5ImageUploading(false);
                        break;
                    case "section5Grid1Icon":
                        setSection5Grid1IconUploading(true);
                        const s5g1Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection5Grid1Icon(s5g1Result.fileUrl);
                        setSection5Grid1IconUploading(false);
                        break;
                    case "section5Grid2Icon":
                        setSection5Grid2IconUploading(true);
                        const s5g2Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection5Grid2Icon(s5g2Result.fileUrl);
                        setSection5Grid2IconUploading(false);
                        break;
                    case "section5Grid3Icon":
                        setSection5Grid3IconUploading(true);
                        const s5g3Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection5Grid3Icon(s5g3Result.fileUrl);
                        setSection5Grid3IconUploading(false);
                        break;
                    case "section6":
                        setSection6ImageUploading(true);
                        const section6Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection6Image(section6Result.fileUrl);
                        setSection6ImageUploading(false);
                        break;
                    case "section7":
                        setSection7ImageUploading(true);
                        const section7Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection7Image(section7Result.fileUrl);
                        setSection7ImageUploading(false);
                        break;
                    case "section9":
                        setSection9ImageUploading(true);
                        const section9Result: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSection9Image(section9Result.fileUrl);
                        setSection9ImageUploading(false);
                        break;
                    case "specPhoto":
                        setSpecPhotoUploading(true);
                        const specResult: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setSpecPhoto(specResult.fileUrl);
                        setSpecPhotoUploading(false);
                        break;
                    case "footer":
                        setFooterImageUploading(true);
                        const footerResult: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setFooterImage(footerResult.fileUrl);
                        setFooterImageUploading(false);
                        break;
                    case "footer_mobile":
                        setFooterImageMobileUploading(true);
                        const footerMobileResult: any = await API.upload(
                            file,
                            "carandx.ae/cms",
                        );
                        setFooterImageMobile(footerMobileResult.fileUrl);
                        setFooterImageMobileUploading(false);
                        break;
                }
            } catch (error) {
                console.log(error);
            }
        }

        // Reset the file input so the same file can be selected again
        if (fileUploadRef.current) {
            fileUploadRef.current.value = "";
        }
    };

    const handleAddSlider = function () {
        const updatedSliders = [...sliders];
        updatedSliders.push({
            image: currentSliderImage,
            title: currentSliderTitle,
            content: currentSliderContent,
        });
        setSliders(updatedSliders);

        // Clear current inputs
        setCurrentSliderImage("");
        setCurrentSliderTitle("");
        setCurrentSliderContent("");
    };

    const handleAddVariantSlider = function () {
        const updatedSliders = [...variantSlider];
        updatedSliders.push({
            image: currentVariantSliderImage,
            title: currentVariantSliderTitle,
            content: currentVariantSliderContent,
        });
        setVariantSlider(updatedSliders);

        // Clear current inputs
        setCurrentVariantSliderImage("");
        setCurrentVariantSliderTitle("");
        setCurrentVariantSliderContent("");
    };

    const handleUpdateVariantSlider = function () {
        const updatedSliders = [...variantSlider];
        const updatedData = {
            image: currentVariantSliderImage,
            title: currentVariantSliderTitle,
            content: currentVariantSliderContent,
        };

        updatedSliders[variantSliderIndex] = updatedData; // was: sliderIndex
        setVariantSlider(updatedSliders);

        setCurrentVariantSliderImage("");
        setCurrentVariantSliderTitle("");
        setCurrentVariantSliderContent("");
    };

    const handleUpdateSlider = function () {
        const updatedSliders = [...sliders];
        const updatedData = {
            image: currentSliderImage,
            title: currentSliderTitle,
            content: currentSliderContent,
        };

        updatedSliders[sliderIndex] = updatedData;
        setSliders(updatedSliders);

        // Clear current inputs
        setCurrentSliderImage("");
        setCurrentSliderTitle("");
        setCurrentSliderContent("");
    };

    const handleDeleteSlider = function (index: number) {
        const updatedSliders = [...sliders];
        updatedSliders.splice(index, 1);
        setSliders(updatedSliders);
    };

    const handleDeleteVariantSlider = function (index: number) {
        const updatedSliders = [...variantSlider];
        updatedSliders.splice(index, 1);
        setVariantSlider(updatedSliders);
    };

    const handleAddSlider2 = function () {
        const updatedSliders = [...slider2];
        updatedSliders.push({
            image: currentSlider2Image,
            title: currentSlider2Title,
            content: currentSlider2Content,
        });
        setSlider2(updatedSliders);

        // Clear current inputs
        setCurrentSlider2Image("");
        setCurrentSlider2Title("");
        setCurrentSlider2Content("");
    };

    const handleUpdateSlider2 = function () {
        const updatedSliders = [...slider2];
        const updatedData = {
            image: currentSlider2Image,
            title: currentSlider2Title,
            content: currentSlider2Content,
        };

        updatedSliders[slider2Index] = updatedData;
        setSlider2(updatedSliders);

        // Clear current inputs
        setCurrentSlider2Image("");
        setCurrentSlider2Title("");
        setCurrentSlider2Content("");
    };

    const handleDeleteSlider2 = function (index: number) {
        const updatedSliders = [...slider2];
        updatedSliders.splice(index, 1);
        setSlider2(updatedSliders);
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div>
            {loading ? (
                <div
                    className="d-flex justify-content-center my-5"
                    style={{ marginTop: 100 }}
                >
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <Container style={{ marginTop: 100, paddingBottom: 200 }}>
                    <Row className="mb-5">
                        <Col
                            cols="6"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 10,
                            }}
                        >
                            <button
                                type="button"
                                className="btn btn-outline-black btn-md mx-1"
                                onClick={() => navigate(-1)}
                            >
                                <i
                                    className="bi bi-chevron-left"
                                    style={{ fontSize: 30 }}
                                ></i>
                            </button>
                            <h1 className="display-6 fw-medium text-primary">
                                Edit Vehicle Model Contents
                            </h1>
                        </Col>
                        <Col cols="6" className="text-end">
                            <button
                                type="button"
                                className="btn btn-primary mx-1"
                                onClick={handleSave}
                                disabled={saveLoading}
                            >
                                <i className="bi bi-save mx-2"></i>
                                {saveLoading ? "Saving..." : "Save"}
                            </button>
                        </Col>
                    </Row>

                    {/* Main Informations */}
                    <Row>
                        {error && (
                            <Col>
                                <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center">
                                    <svg
                                        className="bi flex-shrink-0 me-2"
                                        width="24"
                                        height="24"
                                        role="img"
                                        aria-label="Error:"
                                    >
                                        <use xlinkHref="#exclamation-triangle-fill" />
                                    </svg>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="d-none"
                                    >
                                        <symbol
                                            id="check-circle-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                        </symbol>
                                        <symbol
                                            id="info-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                        </symbol>
                                        <symbol
                                            id="exclamation-triangle-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                        </symbol>
                                    </svg>
                                    <div>
                                        All datas are required to create a
                                        vehicle page. Please make sure all the
                                        required fields are not empty.
                                    </div>
                                    <button
                                        className="btn-close"
                                        onClick={() => setError(false)}
                                    ></button>
                                </div>
                            </Col>
                        )}

                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Main Information
                            </h3>
                        </Col>
                        <Col xs="12" md="6">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Public
                                </label>
                                <select
                                    className="form-select"
                                    value={active}
                                    onChange={(e) => setActive(e.target.value)}
                                >
                                    <option value="">-- Select --</option>
                                    <option value="true">Public</option>
                                    <option value="false">Hidden</option>
                                </select>
                            </div>
                        </Col>
                        <Col xs="12" md="6">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    URL String (Name in url string format)
                                </label>
                                <input
                                    disabled
                                    type="text"
                                    className="form-control"
                                    placeholder="bmw-325i"
                                    value={queryString}
                                    onChange={(e) =>
                                        setQueryString(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="6">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Odoo Vehicle Id
                                </label>
                                <input
                                    disabled
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title 1"
                                    value={odooVehicleId}
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="6">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="BMW 325i"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="6">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Title Color
                                </label>
                                <select
                                    className="form-select"
                                    value={titleColor}
                                    onChange={(e) =>
                                        setTitleColor(e.target.value)
                                    }
                                >
                                    <option value="">-- Select --</option>
                                    <option value="white">White</option>
                                    <option value="black">Black</option>
                                </select>
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Main Section */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Main Section
                            </h3>
                        </Col>
                        <Row>
                            <Col xs="12">
                                <div className="py-3">
                                    <label className="form-label fw-bold">
                                        Main Section Photo (2884 x 1370)
                                    </label>
                                    <div>
                                        {coverImage ? (
                                            <div
                                                style={{ position: "relative" }}
                                            >
                                                <div></div>
                                                <img
                                                    className="px-3 py-4"
                                                    src={coverImage}
                                                    alt="compare-image"
                                                    style={{ width: "100%" }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                                    onClick={() => {
                                                        setCoverImage("");
                                                    }}
                                                    aria-label="Remove image"
                                                >
                                                    <i className="bi bi-x-lg"></i>{" "}
                                                </button>
                                            </div>
                                        ) : (
                                            <img
                                                className="px-3 py-4"
                                                src="/images/no-image-vehicle.png"
                                                alt="no-image"
                                                style={{ width: "100%" }}
                                            />
                                        )}
                                    </div>
                                    <div className="d-flex flex-row justify-content-center">
                                        <button
                                            className="btn btn-secondary btn-sm text-white fw-semibold"
                                            type="button"
                                            disabled={coverImageUploading}
                                            onClick={() => {
                                                setCurrentUpload("main");
                                                fileUploadRef.current.click();
                                            }}
                                        >
                                            <i className="bi bi-upload mx-2 text-white"></i>
                                            {coverImageUploading
                                                ? "Uploading ..."
                                                : "Upload New Photo"}
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12">
                                <div className="py-3">
                                    <label className="form-label fw-bold">
                                        Main Section Photo For Mobile (720x1280)
                                    </label>
                                    <div>
                                        {coverImageMobile ? (
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                }}
                                            >
                                                <img
                                                    className="px-3 py-4"
                                                    src={coverImageMobile}
                                                    alt="cover-image-mobile"
                                                    style={{
                                                        width: 420,
                                                        maxHeight: 874,
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2 rounded-lg"
                                                    onClick={() => {
                                                        setCoverImageMobile("");
                                                    }}
                                                    style={{
                                                        width: "32px",
                                                        height: "32px",
                                                        padding: 0,
                                                    }}
                                                    aria-label="Remove image"
                                                >
                                                    <i className="bi bi-x-lg"></i>{" "}
                                                </button>
                                            </div>
                                        ) : (
                                            <img
                                                className="px-3 py-4"
                                                src="/images/no-image-vehicle.png"
                                                alt="no-image"
                                                style={{
                                                    width: 402,
                                                    height: 874,
                                                    objectFit: "cover",
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div className="d-flex flex-row px-3">
                                        <button
                                            className="btn btn-secondary btn-sm text-white fw-semibold"
                                            type="button"
                                            disabled={coverImageMobileUploading}
                                            onClick={() => {
                                                setCurrentUpload("main_mobile");
                                                fileUploadRef.current.click();
                                            }}
                                        >
                                            <i className="bi bi-upload mx-2 text-white"></i>
                                            {coverImageMobileUploading
                                                ? "Uploading ..."
                                                : "Upload New Photo"}
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Row>
                    <Row>
                        <Col xs="12" md="4">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Sub Title 1
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter sub title 1"
                                    value={subTitle1}
                                    onChange={(e) =>
                                        setSubtitle1(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Sub Title 1 Content
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter sub title 1 content"
                                    value={subTitle1Content}
                                    onChange={(e) =>
                                        setSubTitle1Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="4">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Sub Title 2
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter sub title 2"
                                    value={subTitle2}
                                    onChange={(e) =>
                                        setSubtitle2(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Sub Title 2 Content
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter sub title 2 content"
                                    value={subTitle2Content}
                                    onChange={(e) =>
                                        setSubTitle2Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="4">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Sub Title 3
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter sub title 3"
                                    value={subTitle3}
                                    onChange={(e) =>
                                        setSubtitle3(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Sub Title 3 Content
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter sub title 3 content"
                                    value={subTitle3Content}
                                    onChange={(e) =>
                                        setSubTitle3Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Variant Sliders */}
                    <Row style={{ minHeight: 400, alignItems: "center" }}>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Variant Slider
                            </h3>
                            <label className="form-label fw-bold">
                                Recommended Size (2884 x 1370)
                            </label>
                        </Col>
                        {variantSlider.map((slider: any, index: number) => (
                            <Col xs="6" md="4" className="mt-3" key={index}>
                                <div className="card h-100">
                                    <div className="card-body">
                                        <div className="d-flex flex-row justify-content-between align-items-center">
                                            <button
                                                className="btn"
                                                data-bs-toggle="modal"
                                                data-bs-target="#variantSliderUpdateDialog"
                                                onClick={() => {
                                                    setVariantSliderIndex(
                                                        index,
                                                    );
                                                    setCurrentVariantSliderImage(
                                                        slider.image,
                                                    );
                                                    setCurrentVariantSliderTitle(
                                                        slider.title,
                                                    );
                                                    setCurrentVariantSliderContent(
                                                        slider.content,
                                                    );
                                                }}
                                            >
                                                <i className="bi bi-pencil"></i>
                                            </button>
                                            <button
                                                className="btn"
                                                onClick={() =>
                                                    handleDeleteVariantSlider(
                                                        index,
                                                    )
                                                }
                                            >
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        </div>
                                        <img
                                            src={slider.image}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                        <h6 className="fw-semibold mt-3">
                                            {slider.title}
                                        </h6>
                                        <p>{slider.content}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                        <Col xs="6" md="4" className="mt-3">
                            <button
                                className="card h-100 w-100 d-flex flex-column justify-content-center align-items-center border-0 bg-transparent"
                                data-bs-toggle="modal"
                                data-bs-target="#variantSliderCreateDialog"
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                                    <i
                                        className="bi bi-plus"
                                        style={{ fontSize: 40 }}
                                    ></i>
                                    <p className="mb-0">Add New</p>
                                </div>
                            </button>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Section 1 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Section 1
                            </h3>
                        </Col>
                        <Row>
                            <Col xs="12">
                                <div className="py-3">
                                    <label className="form-label fw-bold">
                                        Section 1 Image
                                    </label>
                                    <div>
                                        {section1Image ? (
                                            <div
                                                style={{ position: "relative" }}
                                            >
                                                <div></div>
                                                <img
                                                    className="px-3 py-4"
                                                    src={section1Image}
                                                    alt="section-image"
                                                    style={{ width: "100%" }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                                    onClick={() => {
                                                        setSection1Image("");
                                                    }}
                                                    aria-label="Remove image"
                                                >
                                                    <i className="bi bi-x-lg"></i>{" "}
                                                </button>
                                            </div>
                                        ) : (
                                            <img
                                                className="px-3 py-4"
                                                src="/images/no-image-vehicle.png"
                                                alt="no-image"
                                                style={{ width: "100%" }}
                                            />
                                        )}
                                    </div>
                                    <div className="d-flex flex-row justify-content-center">
                                        <button
                                            className="btn btn-secondary btn-sm text-white fw-semibold"
                                            type="button"
                                            disabled={section1ImageUploading}
                                            onClick={() => {
                                                setCurrentUpload("section1");
                                                fileUploadRef.current.click();
                                            }}
                                        >
                                            <i className="bi bi-upload mx-2 text-white"></i>
                                            {section1ImageUploading
                                                ? "Uploading ..."
                                                : "Upload New Photo"}
                                        </button>
                                    </div>
                                </div>
                                <div className="py-3">
                                    <label className="form-label fw-bold">
                                        Section 1 Title
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter section 1 title"
                                        value={section1Title}
                                        onChange={(e) =>
                                            setSection1Title(e.target.value)
                                        }
                                    />
                                </div>
                                <div className="py-3">
                                    <label className="form-label fw-bold">
                                        Section 1 Content
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter section 1 content"
                                        value={section1Content}
                                        onChange={(e) =>
                                            setSection1Content(e.target.value)
                                        }
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Row>

                    <div className="divider"></div>

                    {/* Sliders */}
                    <Row style={{ minHeight: 400, alignItems: "center" }}>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">Slider 1</h3>
                            <label className="form-label fw-bold">
                                Recommended Size (2884 x 1370)
                            </label>
                        </Col>
                        {sliders.map((slider: any, index: number) => (
                            <Col xs="6" md="4" className="mt-3" key={index}>
                                <div className="card h-100">
                                    <div className="card-body">
                                        <div className="d-flex flex-row justify-content-between align-items-center">
                                            <button
                                                className="btn"
                                                data-bs-toggle="modal"
                                                data-bs-target="#sliderUpdateDialog"
                                                onClick={() => {
                                                    setSliderIndex(index);
                                                    setCurrentSliderImage(
                                                        slider.image,
                                                    );
                                                    setCurrentSliderTitle(
                                                        slider.title,
                                                    );
                                                    setCurrentSliderContent(
                                                        slider.content,
                                                    );
                                                }}
                                            >
                                                <i className="bi bi-pencil"></i>
                                            </button>
                                            <button
                                                className="btn"
                                                onClick={() =>
                                                    handleDeleteSlider(index)
                                                }
                                            >
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        </div>
                                        <img
                                            src={slider.image}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                        <h6 className="fw-semibold mt-3">
                                            {slider.title}
                                        </h6>
                                        <p>{slider.content}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                        <Col xs="6" md="4" className="mt-3">
                            <button
                                className="card h-100 w-100 d-flex flex-column justify-content-center align-items-center border-0 bg-transparent"
                                data-bs-toggle="modal"
                                data-bs-target="#sliderCreateDialog"
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                                    <i
                                        className="bi bi-plus"
                                        style={{ fontSize: 40 }}
                                    ></i>
                                    <p className="mb-0">Add New</p>
                                </div>
                            </button>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Video 1 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">Video 1</h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Video 1 URL
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter video URL"
                                    value={video1}
                                    onChange={(e) => setVideo1(e.target.value)}
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Section 2 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Section 2
                            </h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 2 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter section 2 title"
                                    value={section2Title}
                                    onChange={(e) =>
                                        setSection2Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 2 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter section 2 content"
                                    value={section2Content}
                                    onChange={(e) =>
                                        setSection2Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="4">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 1 Icon
                                </label>
                                <div>
                                    {section2Grid1Icon ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section2Grid1Icon}
                                                alt="icon"
                                                style={{ width: "100px" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute m-2"
                                                onClick={() => {
                                                    setSection2Grid1Icon("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-icon"
                                            style={{ width: "100px" }}
                                        />
                                    )}
                                </div>
                                <button
                                    className="btn btn-secondary btn-sm text-white fw-semibold"
                                    type="button"
                                    disabled={section2Grid1IconUploading}
                                    onClick={() => {
                                        setCurrentUpload("section2Grid1Icon");
                                        fileUploadRef.current.click();
                                    }}
                                >
                                    <i className="bi bi-upload mx-2 text-white"></i>
                                    {section2Grid1IconUploading
                                        ? "Uploading ..."
                                        : "Upload Icon"}
                                </button>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 1 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter grid 1 title"
                                    value={section2Grid1Title}
                                    onChange={(e) =>
                                        setSection2Grid1Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 1 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter grid 1 content"
                                    value={section2Grid1Content}
                                    onChange={(e) =>
                                        setSection2Grid1Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="4">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 2 Icon
                                </label>
                                <div>
                                    {section2Grid2Icon ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section2Grid2Icon}
                                                alt="icon"
                                                style={{ width: "100px" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute m-2"
                                                onClick={() => {
                                                    setSection2Grid2Icon("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-icon"
                                            style={{ width: "100px" }}
                                        />
                                    )}
                                </div>
                                <button
                                    className="btn btn-secondary btn-sm text-white fw-semibold"
                                    type="button"
                                    disabled={section2Grid2IconUploading}
                                    onClick={() => {
                                        setCurrentUpload("section2Grid2Icon");
                                        fileUploadRef.current.click();
                                    }}
                                >
                                    <i className="bi bi-upload mx-2 text-white"></i>
                                    {section2Grid2IconUploading
                                        ? "Uploading ..."
                                        : "Upload Icon"}
                                </button>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 2 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter grid 2 title"
                                    value={section2Grid2Title}
                                    onChange={(e) =>
                                        setSection2Grid2Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 2 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter grid 2 content"
                                    value={section2Grid2Content}
                                    onChange={(e) =>
                                        setSection2Grid2Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="4">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 3 Icon
                                </label>
                                <div>
                                    {section2Grid3Icon ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section2Grid3Icon}
                                                alt="icon"
                                                style={{ width: "100px" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute m-2"
                                                onClick={() => {
                                                    setSection2Grid3Icon("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-icon"
                                            style={{ width: "100px" }}
                                        />
                                    )}
                                </div>
                                <button
                                    className="btn btn-secondary btn-sm text-white fw-semibold"
                                    type="button"
                                    disabled={section2Grid3IconUploading}
                                    onClick={() => {
                                        setCurrentUpload("section2Grid3Icon");
                                        fileUploadRef.current.click();
                                    }}
                                >
                                    <i className="bi bi-upload mx-2 text-white"></i>
                                    {section2Grid3IconUploading
                                        ? "Uploading ..."
                                        : "Upload Icon"}
                                </button>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 3 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter grid 3 title"
                                    value={section2Grid3Title}
                                    onChange={(e) =>
                                        setSection2Grid3Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 3 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter grid 3 content"
                                    value={section2Grid3Content}
                                    onChange={(e) =>
                                        setSection2Grid3Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Section 3 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Section 3
                            </h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 3 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter section 3 title"
                                    value={section3Title}
                                    onChange={(e) =>
                                        setSection3Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 3 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter section 3 content"
                                    value={section3Content}
                                    onChange={(e) =>
                                        setSection3Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Section 4 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Section 4
                            </h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 4 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter section 4 title"
                                    value={section4Title}
                                    onChange={(e) =>
                                        setSection4Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 4 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter section 4 content"
                                    value={section4Content}
                                    onChange={(e) =>
                                        setSection4Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Slider 2 */}
                    <Row style={{ minHeight: 400, alignItems: "center" }}>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">Slider 2</h3>
                            <label className="form-label fw-bold">
                                Recommended Size (2884 x 1370)
                            </label>
                        </Col>
                        {slider2.map((slider: any, index: number) => (
                            <Col xs="6" md="4" className="mt-3" key={index}>
                                <div className="card h-100">
                                    <div className="card-body">
                                        <div className="d-flex flex-row justify-content-between align-items-center">
                                            <button
                                                className="btn"
                                                data-bs-toggle="modal"
                                                data-bs-target="#slider2UpdateDialog"
                                                onClick={() => {
                                                    setSlider2Index(index);
                                                    setCurrentSlider2Image(
                                                        slider.image,
                                                    );
                                                    setCurrentSlider2Title(
                                                        slider.title,
                                                    );
                                                    setCurrentSlider2Content(
                                                        slider.content,
                                                    );
                                                }}
                                            >
                                                <i className="bi bi-pencil"></i>
                                            </button>
                                            <button
                                                className="btn"
                                                onClick={() =>
                                                    handleDeleteSlider2(index)
                                                }
                                            >
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        </div>
                                        <img
                                            src={slider.image}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                        <h6 className="fw-semibold mt-3">
                                            {slider.title}
                                        </h6>
                                        <p>{slider.content}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                        <Col xs="6" md="4" className="mt-3">
                            <button
                                className="card h-100 w-100 d-flex flex-column justify-content-center align-items-center border-0 bg-transparent"
                                data-bs-toggle="modal"
                                data-bs-target="#slider2CreateDialog"
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                                    <i
                                        className="bi bi-plus"
                                        style={{ fontSize: 40 }}
                                    ></i>
                                    <p className="mb-0">Add New</p>
                                </div>
                            </button>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Section 5 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Section 5
                            </h3>
                            <p className="text-muted small">
                                Note: Upload white/light colored icons for this
                                section
                            </p>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 5 Image
                                </label>
                                <div>
                                    {section5Image ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section5Image}
                                                alt="section-image"
                                                style={{ width: "100%" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                                onClick={() => {
                                                    setSection5Image("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={section5ImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("section5");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {section5ImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 5 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter section 5 title"
                                    value={section5Title}
                                    onChange={(e) =>
                                        setSection5Title(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="4">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 1 Icon (White/Light)
                                </label>
                                <div
                                    style={{
                                        backgroundColor: "#1a1a1a",
                                        padding: "15px",
                                        borderRadius: "8px",
                                    }}
                                >
                                    {section5Grid1Icon ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section5Grid1Icon}
                                                alt="icon"
                                                style={{ width: "100px" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute m-2"
                                                onClick={() => {
                                                    setSection5Grid1Icon("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-icon"
                                            style={{ width: "100px" }}
                                        />
                                    )}
                                </div>
                                <button
                                    className="btn btn-secondary btn-sm text-white fw-semibold mt-2"
                                    type="button"
                                    disabled={section5Grid1IconUploading}
                                    onClick={() => {
                                        setCurrentUpload("section5Grid1Icon");
                                        fileUploadRef.current.click();
                                    }}
                                >
                                    <i className="bi bi-upload mx-2 text-white"></i>
                                    {section5Grid1IconUploading
                                        ? "Uploading ..."
                                        : "Upload White Icon"}
                                </button>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 1 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter grid 1 title"
                                    value={section5Grid1Title}
                                    onChange={(e) =>
                                        setSection5Grid1Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 1 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter grid 1 content"
                                    value={section5Grid1Content}
                                    onChange={(e) =>
                                        setSection5Grid1Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="4">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 2 Icon (White/Light)
                                </label>
                                <div
                                    style={{
                                        backgroundColor: "#1a1a1a",
                                        padding: "15px",
                                        borderRadius: "8px",
                                    }}
                                >
                                    {section5Grid2Icon ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section5Grid2Icon}
                                                alt="icon"
                                                style={{ width: "100px" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute m-2"
                                                onClick={() => {
                                                    setSection5Grid2Icon("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-icon"
                                            style={{ width: "100px" }}
                                        />
                                    )}
                                </div>
                                <button
                                    className="btn btn-secondary btn-sm text-white fw-semibold mt-2"
                                    type="button"
                                    disabled={section5Grid2IconUploading}
                                    onClick={() => {
                                        setCurrentUpload("section5Grid2Icon");
                                        fileUploadRef.current.click();
                                    }}
                                >
                                    <i className="bi bi-upload mx-2 text-white"></i>
                                    {section5Grid2IconUploading
                                        ? "Uploading ..."
                                        : "Upload White Icon"}
                                </button>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 2 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter grid 2 title"
                                    value={section5Grid2Title}
                                    onChange={(e) =>
                                        setSection5Grid2Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 2 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter grid 2 content"
                                    value={section5Grid2Content}
                                    onChange={(e) =>
                                        setSection5Grid2Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                        <Col xs="12" md="4">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 3 Icon (White/Light)
                                </label>
                                <div
                                    style={{
                                        backgroundColor: "#1a1a1a",
                                        padding: "15px",
                                        borderRadius: "8px",
                                    }}
                                >
                                    {section5Grid3Icon ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section5Grid3Icon}
                                                alt="icon"
                                                style={{ width: "100px" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute m-2"
                                                onClick={() => {
                                                    setSection5Grid3Icon("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-icon"
                                            style={{ width: "100px" }}
                                        />
                                    )}
                                </div>
                                <button
                                    className="btn btn-secondary btn-sm text-white fw-semibold mt-2"
                                    type="button"
                                    disabled={section5Grid3IconUploading}
                                    onClick={() => {
                                        setCurrentUpload("section5Grid3Icon");
                                        fileUploadRef.current.click();
                                    }}
                                >
                                    <i className="bi bi-upload mx-2 text-white"></i>
                                    {section5Grid3IconUploading
                                        ? "Uploading ..."
                                        : "Upload White Icon"}
                                </button>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 3 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter grid 3 title"
                                    value={section5Grid3Title}
                                    onChange={(e) =>
                                        setSection5Grid3Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Grid 3 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter grid 3 content"
                                    value={section5Grid3Content}
                                    onChange={(e) =>
                                        setSection5Grid3Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Remaining sections continue in next part... */}
                    {/* Section 6 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Section 6
                            </h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 6 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter section 6 title"
                                    value={section6Title}
                                    onChange={(e) =>
                                        setSection6Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 6 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter section 6 content"
                                    value={section6Content}
                                    onChange={(e) =>
                                        setSection6Content(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 6 Image
                                </label>
                                <div>
                                    {section6Image ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section6Image}
                                                alt="section-image"
                                                style={{ width: "100%" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                                onClick={() => {
                                                    setSection6Image("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={section6ImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("section6");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {section6ImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Section 7 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Section 7
                            </h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 7 Image
                                </label>
                                <div>
                                    {section7Image ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section7Image}
                                                alt="section-image"
                                                style={{ width: "100%" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                                onClick={() => {
                                                    setSection7Image("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={section7ImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("section7");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {section7ImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 7 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter section 7 title"
                                    value={section7Title}
                                    onChange={(e) =>
                                        setSection7Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 7 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter section 7 content"
                                    value={section7Content}
                                    onChange={(e) =>
                                        setSection7Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Section 8 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Section 8
                            </h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 8 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter section 8 title"
                                    value={section8Title}
                                    onChange={(e) =>
                                        setSection8Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 8 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter section 8 content"
                                    value={section8Content}
                                    onChange={(e) =>
                                        setSection8Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Section 9 */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Section 9
                            </h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 9 Image
                                </label>
                                <div>
                                    {section9Image ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={section9Image}
                                                alt="section-image"
                                                style={{ width: "100%" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                                onClick={() => {
                                                    setSection9Image("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={section9ImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("section9");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {section9ImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 9 Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter section 9 title"
                                    value={section9Title}
                                    onChange={(e) =>
                                        setSection9Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Section 9 Content
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter section 9 content"
                                    value={section9Content}
                                    onChange={(e) =>
                                        setSection9Content(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Spec Photo */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">
                                Spec Photo
                            </h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Spec Photo
                                </label>
                                <div>
                                    {specPhoto ? (
                                        <div style={{ position: "relative" }}>
                                            <div></div>
                                            <img
                                                className="px-3 py-4"
                                                src={specPhoto}
                                                alt="spec-photo"
                                                style={{ width: "100%" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                                onClick={() => {
                                                    setSpecPhoto("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4 object-fit-contain"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={specPhotoUploading}
                                        onClick={() => {
                                            setCurrentUpload("specPhoto");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {specPhotoUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className="divider"></div>

                    {/* Footer */}
                    <Row>
                        <Col xs="12">
                            <h3 className="fw-medium text-primary">Footer</h3>
                        </Col>
                        <Col xs="12">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Footer Image
                                </label>
                                <div>
                                    {footerImage ? (
                                        <div style={{ position: "relative" }}>
                                            <img
                                                className="px-3 py-4"
                                                src={footerImage}
                                                alt="footer-image"
                                                style={{ width: "100%" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                                onClick={() => {
                                                    setFooterImage("");
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={footerImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("footer");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {footerImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Footer Image For Mobile (720x1280)
                                </label>
                                <div>
                                    {footerImageMobile ? (
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                            }}
                                        >
                                            <img
                                                className="px-3 py-4"
                                                src={footerImageMobile}
                                                alt="footer-image-mobile"
                                                style={{
                                                    maxWidth: 402,
                                                    maxHeight: 874,
                                                }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2 rounded-lg"
                                                onClick={() => {
                                                    setFooterImageMobile("");
                                                }}
                                                style={{
                                                    width: "32px",
                                                    height: "32px",
                                                    padding: 0,
                                                }}
                                                aria-label="Remove image"
                                            >
                                                <i className="bi bi-x-lg"></i>{" "}
                                            </button>
                                        </div>
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{
                                                width: 402,
                                                height: 874,
                                                objectFit: "cover",
                                            }}
                                        />
                                    )}
                                </div>
                                <div className="d-flex flex-row px-3">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={footerImageMobileUploading}
                                        onClick={() => {
                                            setCurrentUpload("footer_mobile");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {footerImageMobileUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <Row>
                                <Col xs="12" md="6">
                                    <div className="py-3">
                                        <label className="form-label fw-bold">
                                            Footer Title
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter footer title"
                                            value={footerTitle}
                                            onChange={(e) =>
                                                setFooterTitle(e.target.value)
                                            }
                                        />
                                    </div>
                                </Col>
                                <Col xs="12" md="6">
                                    <div className="py-3">
                                        <label className="form-label fw-bold">
                                            Footer Color
                                        </label>
                                        <select
                                            className="form-select"
                                            value={footerTitleColor}
                                            onChange={(e) =>
                                                setFooterTitleColor(
                                                    e.target.value,
                                                )
                                            }
                                        >
                                            <option value="">
                                                -- Select --
                                            </option>
                                            <option value="white">White</option>
                                            <option value="black">Black</option>
                                        </select>
                                    </div>
                                </Col>
                            </Row>

                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Footer Subtitle
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter footer subtitle"
                                    value={footerSubtitle}
                                    onChange={(e) =>
                                        setFooterSubtitle(e.target.value)
                                    }
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            )}

            <input
                type="file"
                ref={fileUploadRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
            />

            {/* Variant slider */}
            <div
                className="modal fade"
                id="variantSliderCreateDialog"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Add New Variant Slider
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Image (2884 x 1370) - (Max 500kb)
                                </label>
                                <div>
                                    {currentVariantSliderImage ? (
                                        <img
                                            className="px-3 py-4"
                                            src={currentVariantSliderImage}
                                            alt="section-image"
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div>
                                    {isFileSizeLarge && (
                                        <Col>
                                            <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center">
                                                <svg
                                                    className="bi flex-shrink-0 me-2"
                                                    width="24"
                                                    height="24"
                                                    role="img"
                                                    aria-label="Error:"
                                                >
                                                    <use xlinkHref="#exclamation-triangle-fill" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="d-none"
                                                >
                                                    <symbol
                                                        id="check-circle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                    </symbol>
                                                    <symbol
                                                        id="info-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                                    </symbol>
                                                    <symbol
                                                        id="exclamation-triangle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                    </symbol>
                                                </svg>
                                                <div>
                                                    File size should not be more
                                                    than 500kb. Selected file
                                                    size{" "}
                                                    {(
                                                        selectedFileSize / 1024
                                                    ).toFixed(2)}
                                                    MB.
                                                </div>
                                                <button
                                                    className="btn-close"
                                                    onClick={() =>
                                                        setIsFileSizeLarge(
                                                            false,
                                                        )
                                                    }
                                                ></button>
                                            </div>
                                        </Col>
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={variantSliderImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("variantSlider");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {variantSliderImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div>
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title"
                                    value={currentVariantSliderTitle}
                                    onChange={(e) =>
                                        setCurrentVariantSliderTitle(
                                            e.target.value,
                                        )
                                    }
                                />
                            </div>
                            <div className="mt-3">
                                <label className="form-label">Content</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter content"
                                    value={currentVariantSliderContent}
                                    onChange={(e) =>
                                        setCurrentVariantSliderContent(
                                            e.target.value,
                                        )
                                    }
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary fw-semibold text-white"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleAddVariantSlider}
                                disabled={variantSliderAddLoading}
                            >
                                <i className="bi bi-save mx-2"></i>
                                {variantSliderAddLoading
                                    ? "Saving ..."
                                    : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Variant Slider Update Dialog */}
            <div
                className="modal fade"
                id="variantSliderUpdateDialog"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Update Variant Slider
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Image (2884 x 1370) - (Max 500kb)
                                </label>
                                <div>
                                    {currentVariantSliderImage ? (
                                        <img
                                            className="px-3 py-4"
                                            src={currentVariantSliderImage}
                                            alt="section-image"
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div>
                                    {isFileSizeLarge && (
                                        <Col>
                                            <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center">
                                                <svg
                                                    className="bi flex-shrink-0 me-2"
                                                    width="24"
                                                    height="24"
                                                    role="img"
                                                    aria-label="Error:"
                                                >
                                                    <use xlinkHref="#exclamation-triangle-fill" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="d-none"
                                                >
                                                    <symbol
                                                        id="check-circle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                    </symbol>
                                                    <symbol
                                                        id="info-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                                    </symbol>
                                                    <symbol
                                                        id="exclamation-triangle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                    </symbol>
                                                </svg>
                                                <div>
                                                    File size should not be more
                                                    than 500kb. Selected file
                                                    size{" "}
                                                    {(
                                                        selectedFileSize / 1024
                                                    ).toFixed(2)}
                                                    MB.
                                                </div>
                                                <button
                                                    className="btn-close"
                                                    onClick={() =>
                                                        setIsFileSizeLarge(
                                                            false,
                                                        )
                                                    }
                                                ></button>
                                            </div>
                                        </Col>
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={variantSliderImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("variantSlider");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {variantSliderImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div>
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title"
                                    value={currentVariantSliderTitle}
                                    onChange={(e) =>
                                        setCurrentVariantSliderTitle(
                                            e.target.value,
                                        )
                                    }
                                />
                            </div>
                            <div className="mt-3">
                                <label className="form-label">Content</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter content"
                                    value={currentVariantSliderContent}
                                    onChange={(e) =>
                                        setCurrentVariantSliderContent(
                                            e.target.value,
                                        )
                                    }
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary fw-semibold text-white"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleUpdateVariantSlider}
                                disabled={variantSliderAddLoading}
                            >
                                <i className="bi bi-save mx-2"></i>
                                {variantSliderAddLoading
                                    ? "Saving ..."
                                    : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Regular Slider Update Dialog */}
            <div
                className="modal fade"
                id="sliderUpdateDialog"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Update Slider
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Image (2884 x 1370) - (Max 500kb)
                                </label>
                                <div>
                                    {currentSliderImage ? (
                                        <img
                                            className="px-3 py-4"
                                            src={currentSliderImage}
                                            alt="section-image"
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div>
                                    {isFileSizeLarge && (
                                        <Col>
                                            <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center">
                                                <svg
                                                    className="bi flex-shrink-0 me-2"
                                                    width="24"
                                                    height="24"
                                                    role="img"
                                                    aria-label="Error:"
                                                >
                                                    <use xlinkHref="#exclamation-triangle-fill" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="d-none"
                                                >
                                                    <symbol
                                                        id="check-circle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                    </symbol>
                                                    <symbol
                                                        id="info-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                                    </symbol>
                                                    <symbol
                                                        id="exclamation-triangle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                    </symbol>
                                                </svg>
                                                <div>
                                                    File size should not be more
                                                    than 500kb. Selected file
                                                    size{" "}
                                                    {(
                                                        selectedFileSize / 1024
                                                    ).toFixed(2)}
                                                    MB.
                                                </div>
                                                <button
                                                    className="btn-close"
                                                    onClick={() =>
                                                        setIsFileSizeLarge(
                                                            false,
                                                        )
                                                    }
                                                ></button>
                                            </div>
                                        </Col>
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={sliderImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("slider");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {sliderImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div>
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title"
                                    value={currentSliderTitle}
                                    onChange={(e) =>
                                        setCurrentSliderTitle(e.target.value)
                                    }
                                />
                            </div>
                            <div className="mt-3">
                                <label className="form-label">Content</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter content"
                                    value={currentSliderContent}
                                    onChange={(e) =>
                                        setCurrentSliderContent(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary fw-semibold text-white"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleUpdateSlider}
                                disabled={sliderAddLoading}
                            >
                                <i className="bi bi-save mx-2"></i>
                                {sliderAddLoading ? "Saving ..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Slider 1 Create Dialog */}
            <div
                className="modal fade"
                id="sliderCreateDialog"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Add New Slider
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Image (2884 x 1370) - (Max 500kb)
                                </label>
                                <div>
                                    {currentSliderImage ? (
                                        <img
                                            className="px-3 py-4"
                                            src={currentSliderImage}
                                            alt="section-image"
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div>
                                    {isFileSizeLarge && (
                                        <Col>
                                            <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center">
                                                <svg
                                                    className="bi flex-shrink-0 me-2"
                                                    width="24"
                                                    height="24"
                                                    role="img"
                                                    aria-label="Error:"
                                                >
                                                    <use xlinkHref="#exclamation-triangle-fill" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="d-none"
                                                >
                                                    <symbol
                                                        id="check-circle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                    </symbol>
                                                    <symbol
                                                        id="info-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                                    </symbol>
                                                    <symbol
                                                        id="exclamation-triangle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                    </symbol>
                                                </svg>
                                                <div>
                                                    File size should not be more
                                                    than 500kb. Selected file
                                                    size{" "}
                                                    {(
                                                        selectedFileSize / 1024
                                                    ).toFixed(2)}
                                                    MB.
                                                </div>
                                                <button
                                                    className="btn-close"
                                                    onClick={() =>
                                                        setIsFileSizeLarge(
                                                            false,
                                                        )
                                                    }
                                                ></button>
                                            </div>
                                        </Col>
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={sliderImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("slider");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {sliderImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div>
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title"
                                    value={currentSliderTitle}
                                    onChange={(e) =>
                                        setCurrentSliderTitle(e.target.value)
                                    }
                                />
                            </div>
                            <div className="mt-3">
                                <label className="form-label">Content</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter content"
                                    value={currentSliderContent}
                                    onChange={(e) =>
                                        setCurrentSliderContent(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary fw-semibold text-white"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleAddSlider}
                                disabled={sliderAddLoading}
                            >
                                <i className="bi bi-save mx-2"></i>
                                {sliderAddLoading ? "Saving ..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Slider 1 Update Dialog */}
            <div
                className="modal fade"
                id="sliderUpdateDialog"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Update Slider
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Image (2884 x 1370) - (Max 500kb)
                                </label>
                                <div>
                                    {currentSliderImage ? (
                                        <img
                                            className="px-3 py-4"
                                            src={currentSliderImage}
                                            alt="section-image"
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div>
                                    {isFileSizeLarge && (
                                        <Col>
                                            <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center">
                                                <svg
                                                    className="bi flex-shrink-0 me-2"
                                                    width="24"
                                                    height="24"
                                                    role="img"
                                                    aria-label="Error:"
                                                >
                                                    <use xlinkHref="#exclamation-triangle-fill" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="d-none"
                                                >
                                                    <symbol
                                                        id="check-circle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                    </symbol>
                                                    <symbol
                                                        id="info-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                                    </symbol>
                                                    <symbol
                                                        id="exclamation-triangle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                    </symbol>
                                                </svg>
                                                <div>
                                                    File size should not be more
                                                    than 500kb. Selected file
                                                    size{" "}
                                                    {(
                                                        selectedFileSize / 1024
                                                    ).toFixed(2)}
                                                    MB.
                                                </div>
                                                <button
                                                    className="btn-close"
                                                    onClick={() =>
                                                        setIsFileSizeLarge(
                                                            false,
                                                        )
                                                    }
                                                ></button>
                                            </div>
                                        </Col>
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={sliderImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("slider");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {sliderImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div>
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title"
                                    value={currentSliderTitle}
                                    onChange={(e) =>
                                        setCurrentSliderTitle(e.target.value)
                                    }
                                />
                            </div>
                            <div className="mt-3">
                                <label className="form-label">Content</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter content"
                                    value={currentSliderContent}
                                    onChange={(e) =>
                                        setCurrentSliderContent(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary fw-semibold text-white"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleUpdateSlider}
                                disabled={sliderAddLoading}
                            >
                                <i className="bi bi-save mx-2"></i>
                                {sliderAddLoading ? "Saving ..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Slider 2 Create Dialog */}
            <div
                className="modal fade"
                id="slider2CreateDialog"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Add New Slider 2
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Image (2884 x 1370) - (Max 500kb)
                                </label>
                                <div>
                                    {currentSlider2Image ? (
                                        <img
                                            className="px-3 py-4"
                                            src={currentSlider2Image}
                                            alt="section-image"
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div>
                                    {isFileSizeLarge && (
                                        <Col>
                                            <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center">
                                                <svg
                                                    className="bi flex-shrink-0 me-2"
                                                    width="24"
                                                    height="24"
                                                    role="img"
                                                    aria-label="Error:"
                                                >
                                                    <use xlinkHref="#exclamation-triangle-fill" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="d-none"
                                                >
                                                    <symbol
                                                        id="check-circle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                    </symbol>
                                                    <symbol
                                                        id="info-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                                    </symbol>
                                                    <symbol
                                                        id="exclamation-triangle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                    </symbol>
                                                </svg>
                                                <div>
                                                    File size should not be more
                                                    than 500kb. Selected file
                                                    size{" "}
                                                    {(
                                                        selectedFileSize / 1024
                                                    ).toFixed(2)}
                                                    MB.
                                                </div>
                                                <button
                                                    className="btn-close"
                                                    onClick={() =>
                                                        setIsFileSizeLarge(
                                                            false,
                                                        )
                                                    }
                                                ></button>
                                            </div>
                                        </Col>
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={slider2ImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("slider2");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {slider2ImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div>
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title"
                                    value={currentSlider2Title}
                                    onChange={(e) =>
                                        setCurrentSlider2Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="mt-3">
                                <label className="form-label">Content</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter content"
                                    value={currentSlider2Content}
                                    onChange={(e) =>
                                        setCurrentSlider2Content(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary fw-semibold text-white"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleAddSlider2}
                                disabled={slider2AddLoading}
                            >
                                <i className="bi bi-save mx-2"></i>
                                {slider2AddLoading ? "Saving ..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Slider 2 Update Dialog */}
            <div
                className="modal fade"
                id="slider2UpdateDialog"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Update Slider 2
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Image (2884 x 1370) - (Max 500kb)
                                </label>
                                <div>
                                    {currentSlider2Image ? (
                                        <img
                                            className="px-3 py-4"
                                            src={currentSlider2Image}
                                            alt="section-image"
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                        <img
                                            className="px-3 py-4"
                                            src="/images/no-image-vehicle.png"
                                            alt="no-image"
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>
                                <div>
                                    {isFileSizeLarge && (
                                        <Col>
                                            <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center">
                                                <svg
                                                    className="bi flex-shrink-0 me-2"
                                                    width="24"
                                                    height="24"
                                                    role="img"
                                                    aria-label="Error:"
                                                >
                                                    <use xlinkHref="#exclamation-triangle-fill" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="d-none"
                                                >
                                                    <symbol
                                                        id="check-circle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                    </symbol>
                                                    <symbol
                                                        id="info-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                                    </symbol>
                                                    <symbol
                                                        id="exclamation-triangle-fill"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                    </symbol>
                                                </svg>
                                                <div>
                                                    File size should not be more
                                                    than 500kb. Selected file
                                                    size{" "}
                                                    {(
                                                        selectedFileSize / 1024
                                                    ).toFixed(2)}
                                                    MB.
                                                </div>
                                                <button
                                                    className="btn-close"
                                                    onClick={() =>
                                                        setIsFileSizeLarge(
                                                            false,
                                                        )
                                                    }
                                                ></button>
                                            </div>
                                        </Col>
                                    )}
                                </div>
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        className="btn btn-secondary btn-sm text-white fw-semibold"
                                        type="button"
                                        disabled={slider2ImageUploading}
                                        onClick={() => {
                                            setCurrentUpload("slider2");
                                            fileUploadRef.current.click();
                                        }}
                                    >
                                        <i className="bi bi-upload mx-2 text-white"></i>
                                        {slider2ImageUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                            </div>
                            <div>
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title"
                                    value={currentSlider2Title}
                                    onChange={(e) =>
                                        setCurrentSlider2Title(e.target.value)
                                    }
                                />
                            </div>
                            <div className="mt-3">
                                <label className="form-label">Content</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter content"
                                    value={currentSlider2Content}
                                    onChange={(e) =>
                                        setCurrentSlider2Content(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary fw-semibold text-white"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleUpdateSlider2}
                                disabled={slider2AddLoading}
                            >
                                <i className="bi bi-save mx-2"></i>
                                {slider2AddLoading ? "Saving ..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditVehicleCMS;
